import { render, staticRenderFns } from "./AppointBox.vue?vue&type=template&id=276ff334&scoped=true"
import script from "./AppointBox.vue?vue&type=script&lang=js"
export * from "./AppointBox.vue?vue&type=script&lang=js"
import style0 from "./AppointBox.vue?vue&type=style&index=0&id=276ff334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ff334",
  null
  
)

export default component.exports